<template>
  <div class="runs-box">
    <div class="d-flex justify-content-between">
      <div class="font-weight-bold">{{ 'Variations' | trans }}</div>
      <span class="badge badge-pro" @click="handleProOrChange">{{ 'PRO' | trans }}</span>
    </div>
    <div>
      <p>
        {{ "You can change how much the resulting image should change."| trans}}
      </p>
    </div>
    <div class="runs-container">
      <div
          v-for="run in runs"
          :class="{ 'active': currentRun.name === run.name, 'disabled': (!isProAndAboveUser) && currentRun.name !== run.name}"
          class="runs-btn"
          @click="handleProOrChange(run.name)"
      >
        {{ run.name | trans }}
        <div
            :class="{ 'active': currentRun.name === run.name}"
            class="checkmark-box"
        >
          <i class="fa fa-check"></i>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import VariationManager from "../../manager/VariationManager";
import user from './../../mixins/user.mixin';
import { EventBus } from '../../events/event.bus';
import { EVENT_PAYMENT_UNLOCK_PRO } from "../../events/payment.events";

export default {
  name: "Variations",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
    user
  ],
  data() {
    return {
      runs: []
    };
  },
  mounted: function () {

  },
  created: function () {
    this.runs = VariationManager.runs;
  },
  methods: {
    handleProOrChange(name) {
      if (this.isProAndAboveUser === false) {
        EventBus.$emit(EVENT_PAYMENT_UNLOCK_PRO, {});
      } else {
        const run = VariationManager.getByName(name);
        this.activeStage.settings.denoising_strength = run.value;
      }
    },
  },
  computed: {
    currentRun() {
      return VariationManager.getByValue(this.activeStage.settings.denoising_strength);
    }
  }
};
</script>
<style lang="scss">
.runs-box {
  gap: 20px;
  display: flex;
  flex-direction: column;
}

.checkmark-box {
  color: white;
  background: #1266F1;
  border-radius: 50%;
  position: absolute;
  padding: 5px;
  width: 24px;
  height: 24px;
  right: -10px;
  top: -13px;
  justify-content: center;
  align-items: center;
  display: none;

  &.active {
    display: flex !important;
  }
}

.runs-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.runs-btn {
  cursor: pointer;
  border-radius: 9px;
  background: #383838;
  position: relative;
  display: flex;
  height: 48px;
  border: 3px solid transparent;
  gap: 10px;
  padding: 10px;
  align-items: center;

  &.active {
    border: 3px solid #1266F1;
  }

  &:hover {
    background: #323232;
  }
}
</style>
